// Hamlib uses a fixed mode vocabulary across all radios (rigctld translates
// to each rig's native modes), unlike Flrig which reports per-radio strings.
export const HAMLIB_MODES = [
  'USB',
  'LSB',
  'CW',
  'CWR',
  'RTTY',
  'RTTYR',
  'AM',
  'AMS',
  'FM',
  'FMN',
  'WFM',
  'PKTUSB',
  'PKTLSB',
  'PKTFM',
  'PKTAM',
  'ECSSUSB',
  'ECSSLSB',
  'C4FM',
  'DSB',
] as const;

export const HAMLIB_BAUD_RATES = [4800, 9600, 19200, 38400, 57600, 115200] as const;
